/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const speedometer = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8 3c-1.925.015-3.703.854-4.986 2.178M8 3v1.244M8 3c1.948.015 3.727.854 5.004 2.178m-12 4.666H2.4m-1.397 0c.056-1.79.82-3.437 2.01-4.666m-2.01 4.666C.99 10.26 1 10.841 1 11.256c0 .687.557 1.244 1.245 1.244h3.888m-3.12-7.322.943.933m9.048-.933-.96.933m.96-.933c1.185 1.228 1.938 2.874 1.993 4.666m0 0H13.6m1.397 0c.012.415.003.997.003 1.412 0 .687-.557 1.244-1.245 1.244H9.867m-3.734 0v-1.244c0-1.017.85-1.756 1.867-1.756.126 0 .249.01.367.031M6.133 12.5h3.734m0 0v-1.244c0-.9-.635-1.575-1.5-1.725m0 0L9 7"
    />
  </svg>
)
export default speedometer
